import { cn } from '@/lib/utils'

interface LoadingStateProps {
  /**
   * Loading message to display
   */
  message?: string
  /**
   * Whether to use full screen height
   */
  fullScreen?: boolean
  /**
   * Additional CSS classes for the container
   */
  className?: string
}

/**
 * Reusable loading state component with consistent styling.
 * Used across detail pages while data is being fetched.
 *
 * @example
 * ```tsx
 * <LoadingState message="Loading move..." />
 * <LoadingState fullScreen />
 * ```
 */
export function LoadingState({
  message = 'Loading...',
  fullScreen = true,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-[#F9F9F9]',
        fullScreen && 'min-h-screen',
        className
      )}
    >
      <div className="text-center">
        <div className="text-[#666666]">{message}</div>
      </div>
    </div>
  )
}
